import { render } from "./AisheView.vue?vue&type=template&id=e6b20358"
import script from "./AisheView.vue?vue&type=script&lang=js"
export * from "./AisheView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__